<template>
  <div
    class="confirmation"
    :class="{
      active: opened == true,
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box d-flex flex-column justify-content-center">
      <div class="confirmation__box__text">
        {{ $t(text) }}
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-center"
      >
        <button class="btn btn-outline-primary mr-3" @click="no()">
          {{ $t("neukladat") }}
        </button>
        <button
          class="btn btn-primary d-flex align-items-center justify-content-center"
          @click="yes()"
        >
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("provestZmeny") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    text: String,
    opened: Boolean,
    centered: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    yes() {
      this.close();
      this.$emit("yes");
    },
    no() {
      this.close();
      this.$emit("no");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
